<template>
  <div class="player-dropdown">
    <a class="dropdown-toggle" title="dropdown-toggle" @click="toggleMore($event, index)">
      <slot name="toggle" />
      <!-- <i class="material-icons">more_horiz</i> -->
    </a>
    <div v-if="openIndex === index" class="dropdown-menu">
      <slot name="menu" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'PlayerDropdown',
  components: {},
  directives: {
  },
  props: {
    index: {
      type: Number,
      required: true,
      default: 0
    },
    openIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      toggleEvent: undefined
    }
  },
  computed: {},
  watch: {
  },
  created() {},
  mounted() {},
  updated() {},
  methods: {
    toggleMore(event, index) {
      if (this.openIndex === index) {
        this.$emit('updateOpenIndex', -1)
      } else {
        this.$emit('updateOpenIndex', index)
        this.toggleEvent = event
        this.$nextTick(() => {
          window.addEventListener('click', this.outsideClickEvent)
        })
      }
    },
    outsideClickEvent(e) {
      if (!(e.target === (this.toggleEvent && this.toggleEvent.target))) {
        this.$emit('updateOpenIndex', -1)
        window.removeEventListener('click', this.outsideClickEvent)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.player-dropdown {
  user-select: none;
  .dropdown-toggle {
    cursor: pointer;
  }
  .dropdown-menu {
    position: relative;
  }
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}
</style>
